import { CloudStore } from "@omni/types/api/store/cloud/store.model";

import { StoreAddress } from "@/components/Address/Address/address.component";
import { useStoreFullName } from "@/components/Store/utils/useStoreFullName.hook";
import { OrderCustomerModel } from "@/redux/modules/api/data/orderDetail/@types/orderCustomer.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    customer: OrderCustomerModel;
    hasCollectProducts: boolean;
    store?: CloudStore;
};

const ContactBlock = ({ customer, hasCollectProducts, store }: Props) => {
    const { t } = useGranite();

    const storeFullName = useStoreFullName(store);

    return (
        <>
            <p>
                {customer.firstName} {customer.lastName}
                <br />
                {customer.email}
                {customer.phone && (
                    <>
                        <br />
                        {customer.phone}
                    </>
                )}
            </p>
            {hasCollectProducts && store && (
                <>
                    <h5 className="font-weight-bold">
                        {t("orderOverview.title.store")}
                    </h5>
                    <StoreAddress
                        address={store.address}
                        storeName={storeFullName}
                    />
                </>
            )}
        </>
    );
};

export default ContactBlock;
